<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button
          variant="primary"
          v-auth="`update`"
          @click="openModal()"
        >
          新增
        </b-button>
      </template>
    </bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="專案名稱"
          v-model="search.name"
          @keyup.enter="getPromotion(1)" />

        <b-button variant="success" @click="getPromotion(1)">搜尋</b-button>
      </div>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getPromotion"
    >
      <template #cell(period)="row">
        {{ convertRocDate(row.item.period_S) }} ~ {{ convertRocDate(row.item.period_E) }}
      </template>

      <template #cell(function)="row">
        <b-button
          variant="info"
          size="sm"
          v-auth="`update`"
          @click="openModal(row.item)"
        >
          編輯
        </b-button>

        <b-button
          variant="danger"
          size="sm"
          v-auth="`update`"
          @click="deletePromotion(row.item.id)"
        >
          刪除
        </b-button>
      </template>
    </tables-page>

    <!-- 契約設定modal -->
    <b-modal
      id="contractPromotionSetting-modal"
      ref="contractPromotionSetting-modal"
      title="契約促銷設定"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
    >
      <b-form-group label-cols="4" label-cols-lg="2" label="組別" label-for="input-default">
        <b-form-select v-model="data.temp_table_data.plan" :options="options.plan"></b-form-select>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="專案名稱" label-for="input-default">
        <b-form-input v-model="data.temp_table_data.name"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="每月促銷金額" label-for="input-default">
        <b-form-input v-model="data.temp_table_data.amount"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="總期數" label-for="input-default">
        <b-form-input v-model="data.temp_table_data.promotionTimes"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="促銷期間" label-for="input-default">
        <div class="d-flex">
          <date-picker
            class="mr-2"
            v-model="data.temp_table_data.period_S"
            :position="'right'"
            placeholder="開始" />

          <date-picker
            v-model="data.temp_table_data.period_E"
            :position="'right'"
            placeholder="結束" />
          <!-- <b-form-datepicker v-model="data.temp_table_data.period_S" placeholder="開始" class="mr-2"></b-form-datepicker>

          <b-form-datepicker v-model="data.temp_table_data.period_E" placeholder="結束"></b-form-datepicker> -->
        </div>
      </b-form-group>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$bvModal.hide('contractPromotionSetting-modal')"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import datePicker from '@/components/common/DatePicker';
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'contractPromotionSetting',
  components: {
    BreadCrumb,
    TablesPage,
    datePicker
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '契約管理', url: '', isActive: true },
          { name: '契約促銷設定', url: '', isActive: false }
        ]
      },
      search: {
        name: '',
      },
      status: {
        isNew: false
      },
      options: {
        plan: [
          { value: 'A', text: 'A' },
          { value: 'B', text: 'B' },
        ]
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "plan",
            label: "組別",
          },
          {
            key: "name",
            label: "專案名稱",
          },
          {
            key: "amount",
            label: "每月促銷金額",
          },
          {
            key: "promotionTimes",
            label: "總期數"
          },
           {
            key: "period",
            label: "促銷期間"
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        page: {},
        temp_table_data: {},
      }
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.contractApi.page);
      this.getPromotion();
    },
    convertRocDate,
    // 開啟編輯modal
    openModal(item = null) {
      this.status.isNew = item ? false : true;

      this.$root.$emit('bv::show::modal', 'contractPromotionSetting-modal');
      this.data.temp_table_data = Object.assign({}, item);
    },
    // 查詢契約促銷設定
    getPromotion(pageIndex = null) {
      const params = {
        ...this.search,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.contractApi.getPromotion((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 新增契約促銷設定 || 更新契約促銷設定
    sumit () {
      const fun = this.status.isNew ? 'addPromotion' : 'updatePromotion';
      this.contractApi[fun]((response) => {
        const res = response.data;

        if (res.code === 0) this.getPromotion();

          this.$root.$emit('bv::hide::modal', 'contractPromotionSetting-modal');
      }, this.data.temp_table_data)
    },
    // 刪除契約促銷設定
    deletePromotion(id) {
      const r = confirm("確定刪除契約促銷設定？");

      if (r) {
        this.contractApi.deletePromotion((response) => {
          const res = response.data;

          if (res.code === 0) this.getPromotion();
        }, id)

        return true;
      }
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  margin-bottom: 20px;
  .search {
    display: flex;
    align-items: center;
    justify-content: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/contractPromotionSetting.vue